export interface PeriodCode {
    title: string;
    value: PeriodCodeValue;
}

export enum PeriodCodeValue {
    'today' = 'today',
    'thisweek' = 'thisweek',
    'last7days' = 'last7days',
    'last30days' = 'last30days',
    'last365days' = 'last365days',
    'range' = 'range'
}
